import { render, staticRenderFns } from "./social-icons.vue?vue&type=template&id=706fced2&scoped=true&"
import script from "./social-icons.vue?vue&type=script&lang=js&"
export * from "./social-icons.vue?vue&type=script&lang=js&"
import style0 from "./social-icons.vue?vue&type=style&index=0&id=706fced2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706fced2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706fced2')) {
      api.createRecord('706fced2', component.options)
    } else {
      api.reload('706fced2', component.options)
    }
    module.hot.accept("./social-icons.vue?vue&type=template&id=706fced2&scoped=true&", function () {
      api.rerender('706fced2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/social-icons.vue"
export default component.exports